'use strict';

var template        = require('../../templates/dashboard/Layout.ejs');
var dashboardHeader = require('../../templates/dashboard/Header.ejs');

var fullScreenMsg = require('../../templates/dashboard/FullScreenMessage.ejs');
var celcomWelcomeTpl = require('../../templates/dashboard/CelcomWelcome.ejs');
var miaWelcomeTpl = require('../../templates/dashboard/MIAWelcome.ejs');

var EmployeesView = require('./Employees');
var ActionLogView = require('./ActionLog');

const FreeAccountSetup = require('../../../commons/views/FreeAccountSetup');

import Alerts from 'lib/alerts';

module.exports = Backbone.View.extend({
    employeesViews: null,

    events: {
        'keyup .js-coupon-code': 'resetCouponError',
        'click .js-apply-coupon-code': 'applyCouponCode',
        'click .js-reset-coupon-code': 'resetCouponCode',
        'click .js-free-account-setup': 'freeAccountSetup'
    },

    initialize: function() {
        return this.render();
    },

    render: function() {
        this.$el.html(template());
        return this;
    },

    renderContent: function(options) {
        this.$('.js-dashboard-header').html(dashboardHeader(options));

        if (!options.isSetupCompany && !options.isAddEmployee) {
            this.employeesView = new EmployeesView({
                $el: this.$('.js-dashboard-employees')
            });
            this.$el.find('.js-dashboard-action-log').html(
                new ActionLogView({
                    collection: options.actionLogs,
                    fetchMore: options.actionLogsFetchMore
                }).render().el
            );
            this.$el.trigger('resize');
            return;
        }

        if (options.isAddEmployee) {
            this.$('.js-dashboard-content').html(fullScreenMsg(options));
            this.$el.trigger('resize');
            return;
        }

        let tags = app.company.get('tags') || [];
        if (tags.indexOf('celcom') >= 0) {
            this.$('.js-dashboard-content').html(celcomWelcomeTpl(
                _.extend(options || {}, {
                    couponCode: app.company.get('couponCode')
                })
            ));
        } else if (tags.indexOf('malaysian-institute-of-accountants') >= 0) {
            this.$('.js-dashboard-content').html(miaWelcomeTpl(
                _.extend(options || {}, {
                    couponCode: app.company.get('couponCode')
                })
            ));
        } else {
            this.$('.js-dashboard-content').html(fullScreenMsg(options));
        }
        this.$el.trigger('resize');
        FreeAccountSetup
            .shouldShowFreeSetup()
            .then(this.toggleFreeAccountSetup);
        return;
    },

    freeAccountSetup: function() {
        return FreeAccountSetup
            .freeAccountSetupRequest()
            .then(this.toggleFreeAccountSetup);
    },

    toggleFreeAccountSetup: function(show) {
        const button = $('.js-free-account-setup');
        if (show) {
            button.show();
        } else {
            button.hide();
        }
    },

    hideLoader: function() {
        this.$('.js-layout-loader').hide();
    },

    // These two methods would be cleaner if I could just call renderContent
    // but that method takes some annoying parameters that are not persisted
    // in the object. Not even sure if I can save them either.
    applyCouponCode: function() {
        let couponCode = this.$('.js-coupon-code').val();
        if (!/^[A-Z0-9]+$/.test(couponCode)) {
            this.toggleCouponError(
                'Your coupon code must be entered in all capital letters and ' +
                'must not contain any special characters'
            );

            return;
        }

        this.toggleCouponError(false);
        app.company.save({couponCode: couponCode}, {skipValidation: true})
            .then(() => {
                Alerts.show('success', {text: 'Your coupon has been saved'});
                this.$('.js-coupon-code').prop('readonly', true);
                this.$('.js-apply-coupon-code').addClass('hidden');
                this.$('.js-reset-coupon-code').removeClass('hidden');
            })
            .fail(()=> {
                Alerts.show('error', {text:
                    'Could not save your coupon code. If the error persist ' +
                    'please contact support. Also know that you can add it ' +
                    'at any time before submitting your first payroll'
                });
            });
    },

    resetCouponCode: function() {
        this.toggleCouponError(false);
        app.company.save({couponCode: null}, {skipValidation: true})
            .then(() => {
                this.$('.js-coupon-code').prop('readonly', false).val('');
                this.$('.js-apply-coupon-code').removeClass('hidden');
                this.$('.js-reset-coupon-code').addClass('hidden');
            });
    },

    resetCouponError: function() {
        this.toggleCouponError(false);
    },

    toggleCouponError: function(err) {
        let $formGroup = this.$('.js-coupon-code-form-group');
        let $error = this.$('.js-coupon-code-form-group .error');

        if (!err) {
            $formGroup.removeClass('has-error');
            $error.text('');
            return;
        }

        $formGroup.addClass('has-error');
        $error.text(err);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/dashboard/Layout.js